import sportsApi from '../../utils/sportsApi';

export const fetchPlacementTypeExamples = async (
    leagueId: number,
    placementTypeId: number,
) => {
    return await sportsApi
        .url(`/leagues/${leagueId}/placement-types/${placementTypeId}/examples`)
        .get()
        .json();
};
